import { IntlShape, useIntl } from 'react-intl';

export type TranslateResourceStringFnType = IntlShape['formatMessage'];

export const useIntlReexport = (): Pick<IntlShape, 'formatMessage'> => {
  const { formatMessage } = useIntl();
  return { formatMessage };
};
